import { css } from "lit";

export const styles = css`
  :host {
    display: inline-flex;
  }

  .badge {
    display: inline-flex;
    align-items: center;
    gap: var(--badge-gap, var(--sds-size-space-150));
    padding: var(--badge-padding, var(--sds-size-space-150) var(--sds-size-space-300));
    border-radius: 9999px;

    font: var(--sds-typography-weight-medium) var(--sds-typography-body-size-small) / 1.5
      var(--sds-typography-family-title);
    letter-spacing: var(--badge-letter-spacing, 0);
    text-transform: uppercase;
    white-space: nowrap;
    height: max-content;

    background: var(--badge-bg, var(--sds-color-background-default-secondary));
    color: var(--badge-color, var(--sds-color-text-default-secondary));
  }

  .badge.small {
    --badge-gap: var(--sds-size-space-100);
    --badge-padding: var(--sds-size-space-100) var(--sds-size-space-200);
  }

  .badge.medium {
    --badge-gap: var(--sds-size-space-200);
    --badge-padding: var(--sds-size-space-200) var(--sds-size-space-400);
  }

  .badge-text {
    flex-shrink: 0;
  }
`;
